import { skipToken } from "@reduxjs/toolkit/query/react";
import { useParams } from "react-router-dom";
import { useClientScope } from "@/components/pages/Client/settings/ClientScopeContext";
import { useGetClientBookingDocumentsQuery } from "@/redux/apis/clientBooking/clientBookingApi";
import { useBookingAttachments } from "./BookingAttachmentsContext";

/**
 * Attachment filenames to show in the Booking Summary box: the booking's EXISTING attachments (minus
 * any staged for removal) plus any newly-picked files. Keeps the summary in sync with the Other Details
 * panel's Attachments field for view/edit. On the create flow there's no `:jobId`, so the document query
 * skips and this is just the picked files (unchanged behaviour). RTK dedupes the query with the panel's.
 */
export const useAttachmentDisplayNames = (): string[] => {
  const { jobId } = useParams<{ jobId?: string }>();
  const { accountId } = useClientScope();
  const { files, removedExistingIds } = useBookingAttachments();
  const { data: existingDocs = [] } = useGetClientBookingDocumentsQuery(
    jobId ? { jobId: Number(jobId), accountId: accountId ?? undefined } : skipToken
  );
  const existing = existingDocs.filter((doc) => !removedExistingIds.includes(doc.uuid)).map((doc) => doc.filename);
  return [...existing, ...files.map((file) => file.name)];
};
